import { render, staticRenderFns } from "./InfoTransferContractSign.vue?vue&type=template&id=17159d1c"
import script from "./InfoTransferContractSign.vue?vue&type=script&lang=js"
export * from "./InfoTransferContractSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports